import React, { Fragment, memo, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Notification from './Notifications/Notification'
import Skeleton from './Notifications/Skeleton'
import { UserNotificationProps } from './types'
import { LoadListDefault, useGet } from '@/api/hooks'
import { GetUserNotification } from '@/api/endpoints'
import { CRRender } from '@/components/crRender'
import Pagination from 'rsuite/esm/Pagination/Pagination'

const UserNotification: React.FC<UserNotificationProps> = ({ isGetNotifications, setIsGetNotifications, className = '' }) => {
  const [reload, toggleReload] = useState(true)

  const [page, setPage] = useState(0)
  const { result: userNotifications, isPending, totalCount } = useGet({
    ...LoadListDefault,
    endPoint: GetUserNotification,
    shortPullTime: 30000,
    defaultValue: [],
    params: [{ page: page, limit: 4}],
    depArr: [reload, page],
    allowFetch: isGetNotifications,
  })


  const { t } = useTranslation()


  return (
    <div className={className}>
      <Skeleton isRender={isPending} />

      <CRRender isRender={!isPending}>
        <CRRender isRender={userNotifications.length > 0}>
          {/* {userNotifications?.map((notification) => ( */}
          <Pagination
            currentPage={page}
            pageSize={4}
            className={'row mx-0  notifications-container-pagging' }
            needTotalInfo={false}
            totalCount={totalCount}
            needArrows
            data={userNotifications}
            handleFilterChange={(key, value) => setPage(value)}
            renderItem={(notification) => (
              <Fragment key={notification.id}>
                <Notification
                  userNotification={notification}
                  toggleReload={toggleReload}
                  setIsGetNotifications={setIsGetNotifications}
                />
              </Fragment>
            )}
          />
          {/* ))} */}
        </CRRender>

        <CRRender isRender={!isPending && userNotifications.length === 0}>
          <div className='notification-container'>
            <span className='notification-alert'>{t("You Don't have Notification")} </span>
          </div>
        </CRRender>
      </CRRender>
    </div>
  )
}

export default memo(UserNotification)

